// Login from the Shopify app (connector contract A): the link carries a one-minute, single-use assertion in the URL
// fragment (`/shopify/sso#assertion=…`), which no server log sees. It is taken out of the address bar before anything
// else reads it (session monitoring records the page URL, the router writes it into the history state): main.ts
// imports this module first. No import here, so that nothing runs before it. The assertion stays in memory only,
// until the /shopify/sso page posts it to client_auth.
// The old connector's link lands on the same page with the id of a link request ("compte à relier") in the fragment
// (`#link=…`), taken out the same way.

export const SHOPIFY_SSO_PATH = '/shopify/sso';
const FRAGMENT_PREFIX = '#assertion=';
const LINK_PREFIX = '#link=';

let pendingAssertion: string | null = null;
let pendingLink: string | null = null;

export function captureShopifySsoAssertion(location: Location = window.location, history: History = window.history): void {
  if (location.pathname.replace(/\/+$/, '') !== SHOPIFY_SSO_PATH) {
    return;
  }
  if (location.hash.startsWith(FRAGMENT_PREFIX)) {
    pendingAssertion = location.hash.slice(FRAGMENT_PREFIX.length) || null;
  } else if (location.hash.startsWith(LINK_PREFIX)) {
    pendingLink = location.hash.slice(LINK_PREFIX.length) || null;
  } else {
    return;
  }
  history.replaceState(history.state, '', `${location.pathname}${location.search}`);
}

// Returns the captured assertion once: a second call (page reload, back button) gets null.
export function takeShopifySsoAssertion(): string | null {
  const assertion = pendingAssertion;
  pendingAssertion = null;
  return assertion;
}

// Returns the captured link request id once, like the assertion.
export function takeShopifyLinkRequest(): string | null {
  const link = pendingLink;
  pendingLink = null;
  return link;
}

if (typeof window !== 'undefined') {
  captureShopifySsoAssertion();
}
